<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-user" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{user.first_name}} {{user.last_name}}</div>
            <div class="meta" v-if="user.email"><i class="fas fa-at fa-fw mr-2"></i>{{user.email}}</div>
            <div class="meta"><i class="fas fa-barcode fa-fw mr-2"></i>{{user.id}}</div>
            <div class="meta suspended" v-if="user.suspension_message"><i class="fas fa-ban fa-fw mr-2"></i>Suspended</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat" v-if="user.counts && user.counts.courseEnrollments"><i class="far fa-book-open"></i>{{user.counts.courseEnrollments}}</span>
                <span class="stat" v-if="user.counts && user.counts.conferenceEnrollments"><i class="far fa-presentation"></i>{{user.counts.conferenceEnrollments}}</span>
                <span class="stat" v-if="user.counts && user.counts.paymentPlans"><i class="far fa-money-check-alt"></i>{{user.counts.paymentPlans}}</span>
            </div>
        </template>
        <template v-slot:details>
            <div class="tile-details">
                <toolbar class="toolbar">
                    <b-tooltip label="Login"><button class="icon-only" @click.stop="login"><i class="far fa-sign-in"></i></button></b-tooltip>
                    <b-tooltip label="User Details"><button class="icon-only" @click.stop="openCard('user-details', {userId: user.id})"><i class="far fa-id-card"></i></button></b-tooltip>
                    <b-tooltip label="User Notes"><button class="icon-only" @click.stop="openCard('user-notes')"><i class="far fa-clipboard"></i></button></b-tooltip>
                    <b-tooltip label="Edit User"><button class="icon-only" @click.stop=""><i class="far fa-pencil"></i></button></b-tooltip>
                    <b-tooltip label="New Note"><button class="icon-only" @click.stop=""><i class="far fa-comment-alt-plus"></i></button></b-tooltip>
                    <b-tooltip label="New Support Ticket"><button class="icon-only" @click.stop=""><i class="far fa-envelope-open-text"></i></button></b-tooltip>
                </toolbar>

                <div class="data mt-1">
                    <data-row mini title="ID">{{user.id}}</data-row>
                    <data-row mini title="Alt E-Mail">{{user.email_2}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'UserTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            user: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false
            }
        },
        methods: {
            login: function () {
                this.$emit('login');
            },
            openCard: function (card, props) {
                this.$openCard(card, props, this.card);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .tile-details {
        margin-top: 0.5rem;
    }

    .meta.suspended {
        color: #dc3545;
        font-weight: 600;
    }
</style>
